import dayjs from "dayjs";

export default (hourAndMinute: string, day: Date = dayjs().toDate()) => {
  const [hour, minute] = hourAndMinute.split(":");
  return dayjs(day)
    .hour(+hour)
    .minute(+minute);
};
